import type { PluginModuleManifest } from '../../../services/app-frontend-service/src/modules/types'
import InstagramAnalyticsPage from './InstagramAnalyticsPage.vue'

// The plugin's page in the app (plan M6). Compiled into the tenant's front image only when the tenant lists the
// plugin (scripts/frontend/build-image.sh). HQ only until the warehouse narrows by franchise (M5).
const manifest: PluginModuleManifest = {
  name: 'instagram-analytics',
  version: '0.3.1',
  platform: '>=1.118.33',
  routes: [
    {
      path: '/relatorios/instagram-unidades',
      name: 'InstagramUnidades',
      component: InstagramAnalyticsPage,
      meta: {
        requiresAuth: true,
        showInMenu: true,
        title: 'Instagram das unidades',
        icon: 'pi-instagram',
        // RelatoriosOS, not Relatorios: both parents are titled "Relatórios", and the general one is the feature
        // `relatorios`, disabled for New Shoes — a child of a hidden parent vanishes from the sidebar (2026-11-04).
        menuParent: 'RelatoriosOS',
        menuOrder: 290,
        permissions: ['Full'],
        feature: 'instagramunidades',
      },
    },
  ],
  translationPages: [],
}

export default manifest
